export default __webpack_public_path__ + "static/media/opensignal.c5daef01.png";